// server api
export const REDIRECT_SLACK_PATH = "/auth/redirect-slack";

export const BUILD_CENTER = "build";
export const LAUNCH_CENTER = "launch";

export const SECOND = 1000;
export const MINUTE = 60 * 1000;
